import React, {Component} from 'react';

import 'sass/ui-kit/box.scss';

class Box extends Component {
    render() {
        let classes = ["box"];

        const direction = this.props.direction ? this.props.direction : "row";
        classes.push("direction-" + direction);
        if (this.props.className) classes.push(this.props.className);

        return <div className={classes.join(" ")}>{this.props.children}</div>;
    }
}

export default Box;


// WEBPACK FOOTER //
// ./src/components/uikit/Box.js